import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { eventsPublicApi } from '../../api/adminApi';
import {
  eventId,
  eventDescription,
  eventDateInputValue,
  formatEventDateShort,
} from '../Admin/Events/eventHelpers';
import './PublicEventPage.css';

function PublicEventPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    eventsPublicApi
      .getOne(id)
      .then((data) => {
        if (!cancelled) setItem(data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err.response?.status === 404) setNotFound(true);
        setItem(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!id) {
    return <Navigate to="/news-calendar" replace />;
  }

  if (loading) {
    return (
      <main className="public-event-page">
        <div className="public-event-inner">
          <p className="public-event-loading">Loading…</p>
        </div>
      </main>
    );
  }

  if (notFound || !item || !eventId(item)) {
    return (
      <main className="public-event-page">
        <div className="public-event-inner">
          <Link to="/news-calendar" className="public-event-back">
            ← News &amp; School Calendar
          </Link>
          <h1 className="public-event-title">Event not found</h1>
          <p className="public-event-muted">This event may have passed or been removed.</p>
          <Link to="/news-calendar" className="btn btn-primary public-event-cta">
            Back to News &amp; Calendar
          </Link>
        </div>
      </main>
    );
  }

  const body = eventDescription(item);
  const dateLabel = formatEventDateShort(eventDateInputValue(item));

  return (
    <main className="public-event-page">
      <div className="public-event-inner">
        <Link to="/news-calendar" className="public-event-back">
          ← News &amp; School Calendar
        </Link>
        <article>
          <p className="public-event-meta">
            <time dateTime={eventDateInputValue(item) || undefined}>{dateLabel}</time>
          </p>
          <h1 className="public-event-title">{item.title || 'Event'}</h1>
          {body ? (
            <div className="public-event-body">{body}</div>
          ) : (
            <p className="public-event-muted">No additional details.</p>
          )}
        </article>
      </div>
    </main>
  );
}

export default PublicEventPage;
